import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainContainer: {
        display: "flex",
        height: "500px",
    },
    leftContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "75% 0 0",
        backgroundColor: theme.palette.backgrounds.main,
    },
    rightContainer: {
        display: "flex",
        flexDirection: "column",
        flex: "25% 0 0",
        padding: `${theme.spacing(6)} ${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(4)}`,
    },
    issueAndActionPlanNumberWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        fontSize: "14px",
        fontFamily: "Open Sans",
    },
    issueAndActionPlanNumberItem: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    formLeft: {
        marginTop: theme.spacing(8),
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(8),
    },
    leftContentWrapper: {
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
    },
    divider: {
        width: "100%",
    },
    footer: {
        justifyContent: "flex-end",
        display: "flex",
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
        gap: theme.spacing(4),
    },
    footerWithThirdButton: {
        display: "flex",
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
        gap: theme.spacing(4),
        justifyContent: "space-between",
    },
    footerMainActions: {
        display: "flex",
        gap: theme.spacing(4),
    },
}));
